import styled from 'styled-components'

const PageTitle = styled.h2`
  font-size: 21px;
  margin-top: 0;
  margin-bottom: 16px;
`

export default PageTitle
